module.exports = __webpack_public_path__ + "static/media/congrats.0f2920d4.svg";